import {
	USER_CF_TYPE,
	REPORTER_TYPE,
	ASSIGNEE_TYPE,
	MULTI_USER_CF_TYPE,
	PEOPLE_CF_TYPE,
} from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FormatRule, EvaluateHandler } from '../../../evaluate-format-rule/types.tsx';
import type { TransformedUserField, TransformedMultiUserField } from '../types.tsx';
import { USER_EMPTY_OPERATORS } from './constants.tsx';

const evaluateHandler: EvaluateHandler<TransformedUserField> = {
	IS: (field, value) => {
		if (value === USER_EMPTY_OPERATORS.UNASSIGNED || value === USER_EMPTY_OPERATORS.EMPTY) {
			return Boolean(!field.value?.accountId);
		}
		return Boolean(field.value?.accountId === value);
	},
	IS_NOT: (field, value) => {
		if (value === USER_EMPTY_OPERATORS.UNASSIGNED || value === USER_EMPTY_OPERATORS.EMPTY) {
			return Boolean(field.value?.accountId);
		}
		return Boolean(field.value?.accountId !== value);
	},
};

const evaluateFormatRule: FormatRule<TransformedUserField> = ({ field, operator, value }) => {
	const evaluateHandlerFn = evaluateHandler[operator];
	if (!evaluateHandlerFn) return false;
	return evaluateHandlerFn(field, value);
};

const evaluateMultiUserHandler: EvaluateHandler<TransformedMultiUserField> = {
	CONTAINS: (field, value) =>
		Boolean(
			Array.isArray(value) &&
				field.value?.filter((fieldValue) => value?.includes(fieldValue.accountId)).length ===
					value.length,
		),
	HAS_ANY_OF: (field, value) =>
		Boolean(
			Array.isArray(value) &&
				field.value?.some((fieldValue) => value?.includes(fieldValue.accountId)),
		),
	DOES_NOT_CONTAIN: (field, value) =>
		Boolean(
			Array.isArray(value) &&
				field.value?.some((fieldValue) => !value?.includes(fieldValue.accountId)),
		),
	IS_EMPTY: (field) => field.value?.length === 0,
	IS_NOT_EMPTY: (field) => field.value?.length > 0,
};

const evaluateFormatRulesForMultiUser: FormatRule<TransformedMultiUserField> = ({
	field,
	operator,
	value,
}) => {
	const evaluateHandlerFn = evaluateMultiUserHandler[operator];
	if (!evaluateHandlerFn) return false;
	return evaluateHandlerFn(field, value);
};

export const userEvaluateFormatRule = {
	[USER_CF_TYPE]: evaluateFormatRule,
	[REPORTER_TYPE]: evaluateFormatRule,
	[ASSIGNEE_TYPE]: evaluateFormatRule,
	[MULTI_USER_CF_TYPE]: evaluateFormatRulesForMultiUser,
	[PEOPLE_CF_TYPE]: evaluateFormatRulesForMultiUser,
};
